document.addEventListener("DOMContentLoaded", () => {
	let unitPrice = document.querySelectorAll(".unit-text.random");
	const listRandomProducts = localStorage.getItem("random-product");

	if(!unitPrice) return;
  var selector;
   if(document.querySelector('#ProductGridContainer')){
  selector = document.querySelector('#ProductGridContainer');
}
   else if(document.querySelector('.product')){
    selector =document.querySelector('.product')
  }


	const productContent = selector
	const remainingStep = window.remainingStep; 
	const textRandom = window.textRandom;
	const remaining = window.remaining;

	let currentTime = new Date();

	const validateHour = (dateIni) => {
		const newDate = new Date();
		const oldDate = new Date(dateIni);
		const diff = newDate - oldDate;
		const diffHour = diff / (1000 * 60 * 60);
		if (diffHour > 1) {
			currentTime = newDate;
		}
		return {
			diff:  diffHour, 
			currentDate: newDate
		};
	};

	const getRandomBoolean = () => {
    	return true;	
      //return Math.random() < 0.5;
	}

	const randomProduct = listRandomProducts ? JSON.parse(listRandomProducts).products : [];

  
	const remainingStepObj = Object.entries(remainingStep);

	let remainingMap = remainingStepObj.map(([prop, value]) => {
		return value > 0 ? value : null;
	});

	const TEXTS_STEP = {
		step_1: textRandom[0],
		step_2: textRandom[1],
		step_3: textRandom[2],
		reset_stock: textRandom[2],
	};

	function objDiff(param) {
		if (param <= remainingMap[0]) {
			return TEXTS_STEP["step_1"];
		} else if (param <= remainingMap[1]) {
			return TEXTS_STEP["step_2"];
		} else if (param <= remainingMap[2]) {
			return TEXTS_STEP["step_3"];
		} else {
			return TEXTS_STEP["reset_stock"];
		}
	}

	/* updateLocal solo se usara para cuando exista, para insertarlo la primera vez no se debe hacer nada */
	const randomLogic = (param = 3, exists = false, updateLocal = false) => {
		unitPrice.forEach((element) => {
			const wrapperContent = element.closest(".unit");
           var selectorinner;
          console.log(element)
          console.log(wrapperContent)
   
 if(wrapperContent.closest(".card__content")){
  selectorinner = wrapperContent.closest('.card__content');
} else if(wrapperContent.closest('.product')){
    selectorinner =wrapperContent.closest('.product')
  }
			const wrapperProduct = selectorinner;
			const unitProgress = wrapperContent.querySelector(".progress_bar.random > div");
			const productId = wrapperProduct.querySelector(".product_id_units").id;

let randomRemaining = Math.floor(Math.random() * 30) + 60;
          console.log("remaining");
            console.log(remaining)
            console.log("randomremaining");
            console.log(randomRemaining)
			if (exists) {
				const { lastHour } = JSON.parse(listRandomProducts);
				const findProduct = randomProduct.find(
					(product) => product.productId === productId
				);
                  console.log("findproduct")
                  console.log(findProduct)
                  console.log("producto")
                  console.log(wrapperProduct)
				if(!findProduct){

                    if (randomRemaining <= 0) {
                        randomRemaining = remaining;
                    }
        
					randomProduct.push({
						productId: productId,
						progressBar: randomRemaining
					});
					currentTime = lastHour;
				} else {
					const { progressBar } = findProduct;
					if(updateLocal){
						randomRemaining = progressBar - param;
                        if (randomRemaining <= 0) {
                            randomRemaining = remaining;
                        }    
						findProduct.progressBar = randomRemaining;
					}else {
						randomRemaining = progressBar;
					}
				}
			} else {
				randomProduct.push({
					productId: productId,
					progressBar: randomRemaining
				});
			}

			if (randomRemaining <= 0) {
				randomRemaining = remaining;
			}

			const randomBoolean =  getRandomBoolean();

			if(randomBoolean){
				unitProgress.style.width = `${randomRemaining}%`;
              console.log("random")
                  console.log(randomRemaining)
				const textDiff = objDiff(randomRemaining);
				element.innerHTML = textDiff;
              var clasecustom = "";
                if(textDiff.includes("pocos")){
                  clasecustom = "nivel4";
                }
              else if(textDiff.includes("Últimas")){
                clasecustom = "nivel2";
              }
              else if(textDiff.includes("Stock")){
                clasecustom = "nivel1";
              }
              else{
                clasecustom = "nivel4";
              }
                wrapperContent.classList.add(clasecustom)
			} else {
				wrapperContent.style.display = 'none';
			}
		});
		localStorage.setItem("random-product", JSON.stringify({
			lastHour: currentTime, 
			products: randomProduct, 
			minusProduct: param
		}));
	};

	if (!listRandomProducts) {
		randomLogic();
	} else {
		let { lastHour } = JSON.parse(listRandomProducts);
		let {diff, currentDate} = validateHour(lastHour);

		if (diff > 1) {
			currentTime = currentDate;
			randomLogic(3, true, true);
		}else{
			randomLogic(0, true, false);
		}
	}

	const mutationGrid = new MutationObserver((mutations) => {
		mutations.forEach(mutation => {
			if(mutation.addedNodes.length > 0){
				unitPrice = document.querySelectorAll(".unit-text.random")
				randomLogic(0, true, false);
			}
		});
	})

	mutationGrid.observe(productContent, { attributes: false, childList: true, subtree: false});
});